import React from "react";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

export const FilesStorageProgressbar = ({ isCompleted, isUploading }) => {
  return !isCompleted && isUploading ? <ColorLinearProgress /> : null;
};

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: "#17a2b854",
  },
  barColorPrimary: {
    backgroundColor: "#17a2b8",
  },
})(LinearProgress);
